<template>
    <div class="tuoshou">
        <div ref="height_top" v-bind:style="{ height: tableHeight + 'px' }" style="overflow: auto;">
            <el-row>
                <el-col :span="24">
                    <div class="container">
                        <!-- 标题 -->
                        <h1 class="header-title">关于库存展示排列顺序</h1>
                        <!-- 核心内容区块 -->
                        <div class="content-block">
                            <p>根据平台“发布审核时间”分享库存数据展示顺序规则</p>
                            <p>优先有图 “1”</p>
                            <p>无图排后 “2”</p>
                            <p>关于库存展示用户标价：</p>
                            <p>根据平台“是否有图”分享是否公开用户标价信息.</p>
                            <p>有图 “显示标价”</p>
                            <p>无图 “不显示标价”</p>
                            <p>关于用户类型</p>
                            <p>个人用户-以手机号为注册的用户,未通过企业认证。</p>
                            <p>企业用户-以手机号注册，且提供企业信息进行认证的用户。</p>
                        </div>
                        <!-- 行动号召区块 -->
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    data() {

        return {
            tableHeight: '',
            tableData: [],
            form: {
                name: '',
            }

        }
    },
    props: [],

    updated() {

    },


    mounted() {

    },

    activated() {

    },
    created() {
        this.tableHeight_fun()
    },
    watch: {

    },
    methods: {
        tableHeight_fun() {
            this.$nextTick(() => {
                this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 100
                console.log(this.tableHeight, 12122)
            })
        },
    }
}
</script>
<style lang="less" scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Microsoft YaHei", Arial, sans-serif;
}

body {
    background-color: #f5f7fa;
    color: #333;
    line-height: 1.6;
    padding: 40px 0;
}

/* 容器样式：居中显示，控制宽度 */
.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

/* 标题样式：突出主题，居中 */
.header-title {
    font-size: 28px;
    font-weight: 700;
    color: #000;
    text-align: center;
    margin-bottom: 20px;
    line-height: 1.4;
}

/* 内容区块样式：白色背景，圆角阴影，内边距 */
.content-block {
    background-color: #fff;
    //border-radius: 8px;
    //box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    padding: 30px 30px;
    margin-bottom: 0px;
    line-height: 1.8;
}

/* 段落样式：间距控制，字体大小 */
.content-block p {
    font-size: 16px;
    margin-bottom: 20px;
    text-align: justify;
}

/* 重点内容高亮：蓝色字体，加粗 */
.highlight {
    color: #000;
    font-weight: 600;
}

/* 行动号召区块：背景色突出，居中对齐 */
.call-to-action {
    background-color: #f0f5ff;
    border-left: 4px solid #000;
    padding: 25px 30px;
    border-radius: 0 8px 8px 0;
    text-align: center;
}

/* 行动号召文字：加粗，字体放大 */
.call-to-action p {
    font-size: 18px;
    font-weight: 600;
    color: #000;
    margin-bottom: 0;
}

/* 响应式适配：小屏幕调整内边距和字体 */
@media (max-width: 768px) {
    .header-title {
        font-size: 24px;
        margin-bottom: 30px;
    }

    .content-block {
        padding: 20px 25px;
    }

    .content-block p {
        font-size: 15px;
    }

    .call-to-action p {
        font-size: 16px;
    }
}
</style>